import { Badge } from '@bambi/component-library/src/components/Badge/Badge';
import { upperFirst } from 'lodash-es';

import type { SpaceTypeEnum } from 'src/common/external/bambi-api/bambiApi';

export function TripSpaceTypeBadge({
  spaceType,
  closeable = false,
  onClose,
}: {
  spaceType: SpaceTypeEnum;
  closeable?: boolean;
  onClose?: () => void;
}) {
  return (
    <Badge
      label={upperFirst(spaceType)}
      color="primary"
      closeable={closeable}
      onClose={onClose}
      testId={`space-type-${spaceType}-badge`}
    />
  );
}
